import { useContent } from "contexts/contentContext/contentContext";
import React from "react";
import IsHelpfulSection from "../Support/IsHelpfulSection";
import SpecificQuestion from "../Support/SpecificQuestion";
import MoreQuestionsNew from "./MoreQuestionsNew";

const QuestionContent = ({ questionDetails, questionsList }) => {
  const { getTextByKey, getPath } = useContent();
  return (
    <div className="support-specific-question">
      {questionDetails && questionDetails.Status && (
        <div className="support-questions-page-container">
          <div className="support-questions-section">
            {questionDetails && questionDetails.Status && (
              <SpecificQuestion question={questionDetails} />
            )}
            <IsHelpfulSection externalSupportQuestion={questionDetails} />
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="support-link-contact-us"
              href={`${getPath()}contact-us?subject=support`}
            >
              {getTextByKey("didnt-find-what-you-are-looking-for")}
            </a>
          </div>
          <MoreQuestionsNew
            questionsList={questionsList}
            question={questionDetails}
          />
        </div>
      )}
    </div>
  );
};

export default QuestionContent;
